export const passwordRulesList = [
  {
    label: ['validation.lessMore', ['8', '14']],
    rules: /^.{8,14}$/
  },
  {
    label: 'validation.charAndNumber',
    rules: 'charsAndDigitsOnly'
  },
  {
    label: 'validation.allChars',
    rules: 'allChars'
  }
];
